var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":_vm.pidChoose ? '请先选择数据分类' : '请选择',"filterable":_vm.filterable},on:{"change":_vm.change},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }